module.exports = __webpack_public_path__ + "static/media/app3.22510f3e.png";